(() => {
  const MINIMUM = 4;

  const normalizeQuantity = (input, announce = false) => {
    if (!input) return true;
    const quantity = Number(input.value);
    if (Number.isInteger(quantity) && quantity >= MINIMUM) return true;
    input.value = MINIMUM;
    if (announce) {
      const message = input.closest('form')?.querySelector('[data-rumiloo-minimum-message]');
      if (message) {
        message.textContent = 'Minimum purchase is 4 pieces of this design.';
        message.focus({ preventScroll: true });
      }
    }
    return false;
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-rumiloo-minimum="4"]')) {
      normalizeQuantity(event.target, true);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector('[name="quantity"][data-rumiloo-minimum="4"]');
    if (input && !normalizeQuantity(input, true)) { event.preventDefault(); event.stopImmediatePropagation(); }
    const invalidCartInput = [...event.target.querySelectorAll('[name="updates[]"][data-rumiloo-minimum="4"]')]
      .find((item) => !normalizeQuantity(item, true));
    if (invalidCartInput) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('.quick_view-qty-minus, .js-qty__adjust--minus, .cart__mini-qty--minus, .cart__popup-qty--minus');
    const input = minus?.parentElement?.querySelector('input[type="number"]');
    if (input?.dataset.rumilooMinimum === String(MINIMUM) && Number(input.value) <= MINIMUM) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = MINIMUM;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-rumiloo-minimum="4"]').forEach((input) => normalizeQuantity(input));
  });
})();

// Mobile menu (mmenu) builds an empty "a.mm-next" arrow for each item with a submenu.
// Give each arrow an accessible name so screen readers and AI agents know what it opens.
(() => {
  const labelSubmenuArrows = () => {
    document.querySelectorAll('a.mm-next:not([aria-label])').forEach((arrow) => {
      if (arrow.textContent.trim()) return;
      const item = arrow.parentElement;
      const sibling = item && [...item.children].find((el) => el !== arrow && (el.matches('a, span')) && el.textContent.trim());
      const name = sibling ? sibling.textContent.replace(/\s+/g, ' ').trim() : '';
      arrow.setAttribute('aria-label', name ? `Open ${name} submenu` : 'Open submenu');
    });
  };
  window.addEventListener('load', labelSubmenuArrows);
  document.addEventListener('DOMContentLoaded', () => setTimeout(labelSubmenuArrows, 0));
})();

// Hidden carousel slides (Slick) and closed mobile-menu panels (mmenu) are marked aria-hidden
// but still contain links and buttons, failing "ARIA hidden element must not be focusable".
// Mirror aria-hidden onto the native `inert` attribute so hidden content is also unfocusable,
// and keep it in sync as slides change and panels open/close.
(() => {
  const SELECTORS = '.slick-slide, .mm-panel';
  const sync = (el) => {
    if (!(el instanceof Element) || !el.matches(SELECTORS)) return;
    const hidden = el.getAttribute('aria-hidden') === 'true';
    el.inert = hidden;
    if (hidden && el.classList.contains('slick-slide')) el.setAttribute('tabindex', '-1');
  };
  const fixMobileMenuLinks = () => {
    // The panel title duplicates the back link and is aria-hidden; keep it clickable but out of tab order.
    document.querySelectorAll('a.mm-title[aria-hidden="true"]').forEach((a) => a.setAttribute('tabindex', '-1'));
    document.querySelectorAll('a.mm-prev:not([aria-label])').forEach((a) => a.setAttribute('aria-label', 'Back to previous menu'));
  };
  const run = () => {
    document.querySelectorAll(SELECTORS).forEach(sync);
    fixMobileMenuLinks();
  };
  let queued = false;
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes') sync(m.target);
      else if (m.addedNodes.length && !queued) {
        queued = true;
        requestAnimationFrame(() => { queued = false; run(); });
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'], childList: true });
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
